import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faPenToSquare,
    faGift,
    faImage,
    faCircleCheck,
    faCopy,
    faLock,
    faEllipsis,
    faMobileScreen,
    faUserPlus,
    faCamera,
    faRefresh,
    faPencil,
    faClock,
    faMap,
    faComments,
    faCalendarPlus,
    faCalendarDays,
    faStar,
    faCalendar,
    faBan,
    faReply,
    faChevronRight,
    faChevronLeft,
    faLocationDot,
    faStore,
    faUser,
    faEllipsisV,
    faCheck,
    faCircleXmark,
    faLink,
    faShieldHalved,
    faGlobe,
    faShareNodes,
    faUsers,
    faTriangleExclamation,
    faBell,
    faMessage,
    faFaceSmile,
} from "@fortawesome/free-solid-svg-icons";

// Add all icons to the library
library.add(
    faPenToSquare,
    faGift,
    faImage,
    faCircleCheck,
    faCopy,
    faLock,
    faEllipsis,
    faMobileScreen,
    faUserPlus,
    faCamera,
    faRefresh,
    faPencil,
    faClock,
    faMap,
    faComments,
    faCalendarPlus,
    faCalendarDays,
    faStar,
    faCalendar,
    faBan,
    faReply,
    faChevronRight,
    faChevronLeft,
    faLocationDot,
    faStore,
    faUser,
    faEllipsisV,
    faCheck,
    faCircleXmark,
    faLink,
    faShieldHalved,
    faGlobe,
    faShareNodes,
    faUsers,
    faTriangleExclamation,
    faBell,
    faMessage,
    faFaceSmile,
);

export { FontAwesomeIcon };
